export default __webpack_public_path__ + "static/Meshery Architecture - Clients-e354ed1b192168b5efc4f451331854be.webp";